import { Spinner } from '@innovationnorway/cl-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import Page from 'src/components/Page/Page';

type Props = {
  text?: string;
};

export const LoadingPage: React.FC<Props> = ({ text }) => {
  const { t: tCommon } = useTranslation();

  const resolvedText = text || tCommon('loading');

  return (
    <Page>
      <div className="padding-y--5 text-align--center display--flex align-items--center flex-direction--column">
        <Spinner aria-label={resolvedText} />
        <p>{resolvedText}</p>
      </div>
    </Page>
  );
};
